import { Toolbar } from '@mui/material'
import { FlexRow } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { AppSettingsContext, MinterAuctionContext } from '../../Contexts'
import { EventsButton, GeotokenButton, MapButton } from '../Components'

const ItemToolbar: React.FC = () => {
  const { auction } = useContext(MinterAuctionContext)
  const { developerMode } = useContext(AppSettingsContext)
  return (
    <Toolbar>
      <FlexRow display="flex">
        <GeotokenButton marginX={0.5} />
        <EventsButton marginX={0.5} />
        <FlexRow display={developerMode ? 'flex' : 'none'} margin={0.5}>
          {auction?.quadkey !== undefined ? <MapButton quadkey={auction?.quadkey} /> : null}
        </FlexRow>
      </FlexRow>
    </Toolbar>
  )
}

export default ItemToolbar
